<template>
    <div>
 
            <!-- blog-area -->
            <section class="mt-50">
                <div class="container">
                    <div class="blog__inner-wrap">
                        <div class="row">
                            
                            <div class="col-70">
                                <div class="blog-post-wrap">
                                    <div class="row gutter-24">
                                        
                                        <div class="col-md-12" v-for="(item, index) in listData" :key="index">
                            <div class="blog__details-wrap">
                                <div class="blog__details-thumb">
                                    <img :src="$store.state.UPLOADS+item.foto" alt="Apexa" />
                                </div>
                                <div class="blog__details-content">
                                    <h2 class="title">{{item.judul}}</h2>
                                    <div class="blog-post-meta">
                                        <ul class="list-wrap">
                                            <li>
                                                <div class="blog-avatar">
                                                    <div class="avatar-content">
                                                        <p>👤 <a href="javascript:void(0)">{{item.createBy}}</a></p>
                                                    </div>
                                                </div>
                                            </li>
                                            <li><i class="fas fa-calendar-alt"></i>{{UMUM.tglConvert(item.createAt).tgl}}</li> 
                                        </ul>
                                    </div> 
                                    <p style="text-align: justify;" v-html="item.isi"></p>
                                     
                                </div>
                                

                            </div>                                               
 
                                        </div>
                                        
                                    </div>
                                    <div class="pagination-wrap mt-40 mb-40">
 
                                    </div>
                                </div>
                            </div>

                <sidecontentnews></sidecontentnews>

                        </div>
                    </div>
                </div>
            </section>
            <!-- blog-area-end -->
       
    </div>
</template>

<script>

import UMUM from '../library/umum';
export default {
    data() {
        return {
            UMUM:UMUM,
            cari : "",
            data_ke : 1, 
            unit_kerja :  "PYRiCmEdcQZdYxrhe",
            jml_data :  0,
            listData:[],
        }
    },
    methods: {

    fetchBerita() {
      // Ganti dengan URL API yang sesuai
        fetch(this.$store.state.URL.berita+'isi_berita', {
            method: "POST",
            headers: {
            "content-type": "application/json", 
            }, 
            body:JSON.stringify({
            id          : this.$route.params.id,
            cari_value  : this.cari,
            data_ke     : this.data_ke, 
            unit_kerja  :  this.unit_kerja
            })
        })
        .then(res => res.json())
        .then(res_data => { 
            this.listData = res_data  
            this.jml_data = res_data  
            console.log(this.listData);
            
        });     
    },


    // PAGINASI
    nextPage() {
        if (this.data_ke < this.jml_data) {
            this.data_ke++;
        }
    },
    
    prevPage() {
        if (this.data_ke > 1) {
            this.data_ke--;
        }
    },
        
    },
    mounted() {
        this.fetchBerita()
    },
}
</script>